import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useCustomTheme } from '../../../context/ThemeContext';
import { createTeacherTheme } from '../../../theme/teacherTheme';
import TeacherLayout from './TeacherLayout';

/**
 * Wraps teacher routes in the teacher-scoped theme (mockup tokens) + top-nav
 * shell. Nested inside the app's global ThemeContextProvider, so it overrides
 * the theme for teacher surfaces only — Admin and Student are untouched, and
 * the shared light/dark `mode` + `colorTheme` preference still comes from
 * ThemeContext. Mirrors StudentShell.
 */
const TeacherShell = ({ children }) => {
  const { mode, colorTheme } = useCustomTheme();
  const theme = useMemo(() => createTeacherTheme(mode, colorTheme), [mode, colorTheme]);

  return (
    <ThemeProvider theme={theme}>
      <TeacherLayout>{children}</TeacherLayout>
    </ThemeProvider>
  );
};

export default TeacherShell;
